import React from "react";
import { LOCATION_TYPES } from "../../../../helpers/consts";
import Locations from "../../../Locations";

const Warehouse = ({ asset }) => {
  return <Locations asset={asset} type={LOCATION_TYPES.WARHOUSE} />;
};

export default Warehouse;
